<template>
<div class="k-page-content" v-loading="loading">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="客户详情" name="first">
                <div class="k-page-common">
                    <div class="k-common-header" style="padding: 12px;">
                        <div class="proDeTitle">
							<div>
								<span class="t1">客户详情：</span>
								<span class="t2">{{customerData.customer.customer_name}}（{{customerData.customer.customer_code}}）</span>
								<span class="t3">{{customerData.customer.status_txt}}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="whiteBox" style="padding-bottom: 0;">
                            	<div class="projectDetailTop">
									<div class="tyTitle">
										<p>基本信息</p>
									</div>
									<layoutStep v-if="customerData.customer.customer_name" :stepinfo="customerData"></layoutStep>
									<div class="detailBox">
										<ul>
											<li>
												<div class="title">客户简称</div>
												<div class="con">{{customerData.customer.customer_as}}</div>
											</li>
											<li>
												<div class="title">客户类型</div>
												<div class="con">{{customerData.customer.customer_type_txt}}</div>
											</li>
											<li>
												<div class="title">成立日期</div>
												<div class="con">{{customerData.customer.date_of_establishment_txt}}</div>
											</li>
											<li>
												<div class="title">法定代表人</div>
												<div class="con">{{customerData.customer.legal_representative}}</div>
											</li>
											<li>
												<div class="title">商务</div>
												<div class="con">{{customerData.customer.business_docking_id_txt}}</div>
											</li>
											<li>
												<div class="title">税号</div>
												<div class="con">{{customerData.customer.customer_number}}</div>
											</li>
											<li>
												<div class="title">注册资本(万元)</div>
												<div class="con">{{customerData.customer.registered_capital}}</div>
											</li>
											<li>
												<div class="title">状态</div>
												<div class="con" style="color: #409eff;">{{customerData.customer.status_txt}}</div>
											</li>
											<!-- <li>
												<div class="title">营业执照</div>
												<div class="con">
													<el-link type="primary" :href="customerData.customer.business_license_pic_txt" target="_blank">预览</el-link>
												</div>
											</li> -->
											<li>
												<div class="title">执照到期时间</div>
												<div class="con">{{customerData.customer.end_type_txt}}</div>
											</li>
											<li style="width: 100%; align-items: baseline;">
												<div class="title">经营范围</div>
												<div class="con" style="white-space: normal; height: auto; overflow: auto; line-height: 24px;">{{customerData.customer.business_scope}}</div>
											</li>
											
										</ul>
									</div>
									<div class="tyTitle">
										<p>联系人与对接人</p>
									</div>
									<div class="detailBox">
										<ul>
											<li>
												<div class="title">联系人姓名</div>
												<div class="con">{{customerData.Link.name_txt}}</div>
											</li>
											<li>
												<div class="title">联系人电话</div>
												<div class="con">{{customerData.Link.link_phone}}</div>
											</li>
											<li>
												<div class="title">联系人邮箱</div>
												<div class="con">{{customerData.Link.email}}</div>
											</li>
											<li>
												<div class="title">联系人职位</div>
												<div class="con">{{customerData.Link.position}}</div>
											</li>
											<li style="width: 100%">
												<div class="title">对接人</div>
												<div class="con">
													<span v-for="(item,index) in customerData.duijieren">
														{{item.uid_txt}}
														<i v-if="index < customerData.duijieren.length-1">、</i>
													</span>
												</div>
											</li>
										</ul>
									</div>
									<div class="tyTitle">
										<p>数据状态</p>
									</div>
									<div class="detailBox">
										<ul class="wid20">
											<li>
												<div class="title">项目总额</div>
												<div class="con">{{customerData.all_info.all_cost}}</div>
											</li>
											<li>
												<div class="title">执行中的金额</div>
												<div class="con">{{customerData.all_info.execute_cost}}</div>
											</li>
											<li>
												<div class="title">执行中项目数</div>
												<div class="con">{{customerData.all_info.execute_num}}</div>
											</li>
											<li>
												<div class="title">未执行项目数</div>
												<div class="con">{{customerData.all_info.no_execute_num}}</div>
											</li>
											<li>
												<div class="title">平均账期</div>
												<div class="con">{{customerData.all_info.average_period}}</div>
											</li>
										</ul>
									</div>
									<div class="tyTitle">
										<p>风险信息</p>
									</div>
									<div class="detailBox">
										<ul class="wid20">
											<li>
												<div class="title">是否预付款</div>
												<div class="con">{{customerData.fengxian.is_advance_txt}}<template v-if="customerData.fengxian.is_advance == 1">,{{customerData.fengxian.advance_payment}}</template></div>
											</li>
											<li>
												<div class="title">账期(天)</div>
												<div class="con">{{customerData.fengxian.period}}</div>
											</li>
											<li>
												<div class="title">剩余授信额度</div>
												<div class="con">{{customerData.fengxian.credit_line}}{{customerData.fengxian.credit_line == '--' ? '' : '元'}}</div>
											</li>
											<li>
												<div class="title">最低利润率(%)</div>
												<div class="con">{{customerData.fengxian.minimum_profit_margin}}</div>
											</li>
											<li>
												<div class="title">平均利润率(%)</div>
												<div class="con">{{customerData.fengxian.average_profit_margin}}</div>
											</li>
										</ul>
									</div>
								</div>
                            </div>
							<!-- <div class="projectDetailCenter">
								<div class="whiteBox left">
									<div class="tyTitle">
										<p>数据状态</p>
									</div>
								</div>
								<div class="whiteBox right">
									<div class="tyTitle">
										<p>风险信息</p>
									</div>
								</div>
							</div> -->
							<div class="whiteBox projectDetailBottom">
								<el-tabs v-model="bottomActiveName">
								    <el-tab-pane label="开票信息" name="invoice"></el-tab-pane>
									<el-tab-pane label="合同信息" name="contract"></el-tab-pane>
								</el-tabs>
								<template v-if="bottomActiveName == 'invoice'">
									<div style="margin-top: 15px;">
										<el-table
										        :data="tableData.invoice"
										        style="width: 100%"
										        row-key="id"
												border
												stripe
										        ref = "tableinvoice"
										        highlight-current-row>
												<el-table-column
														fixed
														prop="company_name"
														label="公司名称"
														min-width="200">
												</el-table-column>
												<el-table-column
												        prop="ird"
												        label="税号"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="address"
												        label="单位地址"
												        min-width="150">
												</el-table-column>
												<el-table-column
												        prop="phone"
												        label="电话号码"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="bank_of_deposit_txt"
												        label="开户行"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="bank_branch_txt"
												        label="开户行及支行"
												        min-width="270">
												</el-table-column>
												<el-table-column
												        prop="bank_card"
												        label="银行账户"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="refund_account_txt"
												        label="回款账户"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="invoice_type_txt"
												        label="发票信息"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="idcard_prove_txt"
												        label="营业执照"
												        width="120">
																<template slot-scope="scope">
															  <el-link v-if="scope.row.idcard_prove_txt" style="font-size: 14px;" type="primary" :href="scope.row.idcard_prove_txt" target="_blank">预览</el-link>
															  <span v-else>--</span>
														</template>
												</el-table-column>
												<el-table-column
												        prop="taxpayer_prove_txt"
												        label="一般纳税人证明"
												        width="120">
														<template slot-scope="scope">
															  <el-link v-if="scope.row.taxpayer_prove_txt" style="font-size: 14px;" type="primary" :href="scope.row.taxpayer_prove_txt" target="_blank">预览</el-link>
															  <span v-else>--</span>
														</template>
												</el-table-column>
												<el-table-column
												        prop="invoice_prove_txt"
												        label="开户许可证"
												        width="100">
														<template slot-scope="scope">
															  <el-link v-if="scope.row.invoice_prove_txt" style="font-size: 14px;" type="primary" :href="scope.row.invoice_prove_txt" target="_blank">预览</el-link>
															  <span v-else>--</span>
														</template>
												</el-table-column>
												<el-table-column
												        prop="fp_attachment_txt"
												        label="发票证明"
												        width="100">
														<template slot-scope="scope">
															  <el-link v-if="scope.row.fp_attachment_txt" style="font-size: 14px;" type="primary" :href="scope.row.fp_attachment_txt" target="_blank">预览</el-link>
															  <span v-else>--</span>
														</template>
												</el-table-column>
												<el-table-column
														fixed="right"
												        prop="default"
												        label="是否默认"
												        width="80">
														<template slot-scope="scope">
															<el-tag size="mini" effect="dark" v-if="scope.row.default == 'YES'">默认</el-tag>
															<el-tag size="mini" effect="plain" v-if="scope.row.default == 'NO'">非默认</el-tag>
														</template>
												</el-table-column>
												<el-table-column
												        prop="is_disable_txt"
												        label="是否启用"
												        width="80">
												</el-table-column>
												<el-table-column
														fixed="right"
												        prop="status_txt"
												        label="状态"
												        width="80">
												</el-table-column>
										</el-table>
									</div>
								</template>
								<template v-if="bottomActiveName == 'contract'">
									<div style="margin-top: 15px;">
										<el-table
										        :data="tableData.contract"
										        style="width: 100%"
										        row-key="id"
												border
												stripe
										        ref = "tablecontract"
										        highlight-current-row>
												<el-table-column
														fixed
														prop="type_txt"
														label="合同类型"
														min-width="100">
												</el-table-column>
												<el-table-column
												        prop="contract_code"
												        label="合同编码"
												        width="200">
												</el-table-column>
												<el-table-column
												        prop="name"
												        label="合同名称"
												        min-width="150">
												</el-table-column>
												<el-table-column
												        prop="related_contracts"
												        label="关联父级合同"
												        width="120">
												</el-table-column>
												<el-table-column
												        prop="contract_amount"
												        label="合同金额(元)"
												        min-width="110">
												</el-table-column>
												<el-table-column
												        prop="sign_time"
												        label="签订日期"
												        width="110">
												</el-table-column>
												<el-table-column
												        label="有效期"
												        width="200">
														<template slot-scope="scope">
															  <span>{{scope.row.sign_start_time}}~{{scope.row.sign_end_time}}</span>
														</template>
												</el-table-column>
												<el-table-column
												        prop="is_lock_txt"
												        label="是否锁价"
												        width="80">
												</el-table-column>
												<el-table-column
												        prop="status_txt"
												        label="状态"
												        width="80">
												</el-table-column>
												<el-table-column
												        prop="uid_txt"
												        label="操作人"
												        width="100">
												</el-table-column>
												<el-table-column
												        prop="create_time"
												        label="添加日期"
												        width="110">
												</el-table-column>
										</el-table>
									</div>
								</template>
							</div>
                        </div>
						<actionBar v-if="queryParams.type == 'approve' && customerData.customer.customer_name" :actioninfo="customerData" :loading.sync="loading"></actionBar>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
</div>
</template>
<script>
import layoutStep from '../approve/Step.vue'
import actionBar from '../approve/Actionbar.vue'
export default {
  props: ['info'],
  components: {
    layoutStep,
  	actionBar
  },
  data() {
      return {
          activeName: 'first',
          size:'mini',
  		  loading:false,
  		  bottomActiveName:'invoice',
  		  customerData:{
			  Link:{},//联系人
			  all_info:{},//数据状态
			  bank_card:[],//银行卡
			  contract:[],//合同
			  customer:{},//客户基本信息
			  duijieren:[],//对接人
			  fengxian:{},//风险信息
			  invoice:[],//发票信息
			  step_info:{}//流程信息
  		  },
          tableData: {
              invoice:[],
			  contract:[]
          },
  		  queryParams:''//跳转页面携带参数
      }
  },
  computed: {
  },
  mounted: function () {
  	  this.loading = true
  	  this.queryParams = this.$route.query;
  	  this.getDetail()
  },
  methods: {
  		//获取详情
  		getDetail(){
  			let params={}
  			params.id = this.queryParams.id
  			if(this.queryParams.set_id){
  				params.set_id = this.queryParams.set_id
  			}
  			if(this.queryParams.log_id){
  				params.log_id = this.queryParams.log_id
  			}
  			this.$api.get('/admin/customers/customer/getexamineinfoview',params).then(res => {
  				if (res.code === 0) {
  					this.customerData = res.data
					this.tableData.invoice = this.customerData.invoice
					this.tableData.contract = this.customerData.contract
  					this.loading = false
  				} else {
  				  this.$message.error(res.msg);
  				}
  			})
  		},
		goBack(){
			// this.$router.go(-1);
			window.history.back()
		}
  }
}
</script>
<style lang="scss" scoped>
.resourceCon{
	.addBox{
		margin-top: 60px;
	}
	.fyRadio{
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 20px;
			    height: 20px;
			    margin-right: 6px;
		}
		.fyRadioTitle{
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}
	.el-radio{
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}
.projectDetailInfo{
	position: relative;
	padding-left: 60px;
	height: 100%;
	margin-top: 20px;
	padding-bottom: 10px;
	.base-info-wrap{
	    margin-bottom: 10px;
		.row{
		    display: flex;
		    font-size: 14px;
		    align-items: center;
			flex-wrap: wrap;
			.column{
			    width: 20%;
				padding-bottom: 14px;
				.column-label{
				    margin-right: 14px;
				    color: #a1a1a1;
				}
				.column-value {
				    word-break: break-all;
				    color: #333;
					&.red {
					    color: #fb5555 !important;
					    font-weight: 500;
					}
				}
			}
		}
	}
	.bg{
	    position: absolute;
	    top: 0;
	    left: -24px;
	    width: 36px;
	    height: 100%;
	    background: url(../../assets/images/titbg.png) no-repeat;
	    background-size: 100% 100%;
	    writing-mode: vertical-lr;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    padding-left: 6px;
	    font-size: 14px;
	    text-indent: 10px;
	    letter-spacing: 12px;
	    color: #775905ec;
		border-radius:8px;
		overflow: hidden;
	}
	.des{
	    position: relative;
	    color: #333;
	    background: #f9fafd;
	    border-radius: 8px;
	    padding: 6px 10px;
	    line-height: 30px;
	    margin-top: -14px;
	    font-size: 14px;
		div{
		    white-space: pre-wrap;
		}
		span{
		    font-weight: bolder;
		    white-space: nowrap;
		}
		.desdemand {
		    padding: 10px;
		}
	}
}
.projectDetailCenter{
	display: flex;
	justify-content: space-between;
	.left{
		width: calc(100% - 370px);
		height: 240px;
	}
	.right{
		width: 350px;
		height: 240px;
	}
}
</style>